import React, { useState, useEffect } from "react";
import { FormStyles, TextStyles } from "styles/style";
import { useAuth } from "hooks/auth";
import { api } from "supabase/database/api.ts";
import DataTable from "./DataTable";

export default () => {
  const { user } = useAuth();
  const [careerData, setCareerData] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [formData, setFormData] = useState({
    company_name: '',
    period: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const columns = [
    { key: 'company_name', header: 'Company/Organization Name' },
    { key: 'period', header: 'Period' }
  ];

  useEffect(() => {
    if (user?.email) {
      loadData();
    }
  }, [user?.email]);

  const loadData = async () => {
    try {
      const data = await api.dataQueries.GetUserData({ 
        table: 'career_info', 
        email: user.email 
      });
      setCareerData(data);
    } catch (error) {
      console.error("Error loading career data:", error);
    }
  };

  const handleFieldChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleAdd = () => {
    setFormData({
      company_name: '',
      period: ''
    });
    setEditingIndex(null);
    setShowForm(true);
  };

  const handleEdit = (row, index) => {
    setFormData(row);
    setEditingIndex(index);
    setShowForm(true);
  };

  const handleCancel = () => {
    setShowForm(false);
    setEditingIndex(null);
    setFormData({
      company_name: '',
      period: ''
    });
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    try {
      if (editingIndex !== null) {
        await api.dataMutations.UpdateData({ 
          table: 'career_info',
          id: careerData[editingIndex].id, 
          data: formData 
        });
      } else {
        await api.dataMutations.CreateData({ 
          table: 'career_info',
          data: { ...formData, user_email: user.email }
        });
      }
      
      alert("Career information saved successfully!");
      setShowForm(false);
      loadData();
    } catch (error) {
      alert("Failed to save career information");
      console.error("Error saving career information:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (showForm) {
    return (
      <FormStyles.FormContainer>
        <FormStyles.FormHeader>
          <FormStyles.FormTitle>
            {editingIndex !== null ? 'Edit' : 'Add'} Career Information
          </FormStyles.FormTitle>
          <FormStyles.FormBackButton onClick={handleCancel}>
            ← Back to List
          </FormStyles.FormBackButton>
        </FormStyles.FormHeader>
        
        <FormStyles.Form onSubmit={onSubmit}>
          <FormStyles.FormRow>
            <FormStyles.FormLabel>Company/Organization Name</FormStyles.FormLabel>
            <TextStyles.SearchInput
              type="text"
              value={formData.company_name || ''}
              onChange={(e) => handleFieldChange("company_name", e.target.value)}
              placeholder="Enter company or organization name"
              required
            />
          </FormStyles.FormRow>

          <FormStyles.FormRow>
            <FormStyles.FormLabel>Period</FormStyles.FormLabel>
            <TextStyles.SearchInput
              type="text"
              value={formData.period || ''}
              onChange={(e) => handleFieldChange("period", e.target.value)}
              placeholder="e.g., Jan 2020 - Dec 2022"
              required
            />
          </FormStyles.FormRow>

          <FormStyles.FormButtonGroup>
            <FormStyles.FormSubmitButton type="submit" disabled={isSubmitting}>
              {isSubmitting ? "Saving..." : "Save"}
            </FormStyles.FormSubmitButton>
            <FormStyles.FormCancelButton
              onClick={handleCancel}
            >
              Cancel
            </FormStyles.FormCancelButton>
          </FormStyles.FormButtonGroup>
        </FormStyles.Form>
      </FormStyles.FormContainer>
    );
  }

  return (
    <FormStyles.FormContainer>
      <DataTable
        data={careerData}
        columns={columns}
        onEdit={handleEdit}
        onAdd={handleAdd}
        title="Work/Job Career"
      />
    </FormStyles.FormContainer>
  );
};